import { render } from "./TheFooterContact.vue?vue&type=template&id=16235e80&scoped=true"
const script = {}

import "./TheFooterContact.vue?vue&type=style&index=0&id=16235e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16235e80"]])

export default __exports__